import { render } from "./IndexMgmt.vue?vue&type=template&id=b48927be&scoped=true"
import script from "./IndexMgmt.vue?vue&type=script&lang=js"
export * from "./IndexMgmt.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b48927be"

export default script